import axios from 'axios';
import { toast } from 'react-toastify';

const showToast = (message, type = 'success') => {
  const options = {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'dark',
  };
  type === 'success' ? toast.success(message, options) : toast.error(message, options);
};

axios.interceptors.response.use(
  response => { 
    response.config.method !== 'get' && response.status === 200 && showToast('Operation completed successfully!', 'success');
    return response;
  },
  error => {
    const { response } = error;
    let message = response?.data?.error || response?.data?.errors?.join(', ') ||
    (response?.status >= 500 ? 'Server Error. Try again later.' : response?.status >= 400 ? 'An unexpected error occurred!' : 'Unknown error occurred.');
    if (response?.status === 401) message = "Unauthorized. Please log in!"
    showToast(message, 'error');  
    return Promise.reject(error);
  }
);

export default axios;

